import { configureStore } from '@reduxjs/toolkit'
import appReducer from './slices/appSlice'
import quickTaskReducer from './slices/quickTaskSlice'
import taskReducer from './slices/taskSlice'
import userReducer from './slices/userSlice'
import orderReducer from './slices/orderSlice'
import adminSlice from './slices/adminSlice'
import settingSlice from './slices/settingSlice'
import pointCardSlice from './slices/pointCardSlice'
import vipCardSlice from './slices/vipCardSlice'
import memberLevelConfigSlice from './slices/memberLevelConfigSlice'
import labelSlice from './slices/labelSlice'
import modelCategorySlice from './slices/modelCategorySlice'
import apiKeySlice from './slices/apiKeySlice'
import authSlice from './slices/authSlice'
import shareKeySlice from './slices/shareKeySlice'
import socialSlice from './slices/socialSlice'
import socialTypeSlice from './slices/socialTypeSlice'
import socialTagSlice from './slices/socialTagSlice'

// 使用 configureStore 自动设置 Redux DevTools 和其他中间件
export const store = configureStore({
  reducer: {
    app: appReducer,
    quickTask: quickTaskReducer,
    task: taskReducer,
    user: userReducer,
    order: orderReducer,
    admin: adminSlice,
    setting: settingSlice,
    pointCard: pointCardSlice,
    vipCard: vipCardSlice,
    memberLevelConfig: memberLevelConfigSlice,
    label: labelSlice,
    modelCategory: modelCategorySlice,
    apiKey: apiKeySlice,
    auth: authSlice,
    shareKey: shareKeySlice,
    social: socialSlice,
    socialType: socialTypeSlice,
    socialTag: socialTagSlice
  },
  // Redux DevTools 默认已启用，无需额外配置
  devTools: process.env.NODE_ENV !== 'production' // 生产环境自动禁用
})

export default store